import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';
const valEmp = __CONFIG__.empresa;

const COLABORADOR = 'COLABORADOR';
const LISTADO = 'LISTADO';
const TIPO = 'TIPO';
const PUESTO = 'PUESTO';
const LOADER = 'LOADER';
const MODULO = 'MODULO';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listarColaborador = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id };
    }else{
        id = id_emp[5];
        params = { id };
    }
    api.get('/colaborador/empresa_colaborador_pais', params).then(data => {
        const lista = [];
        if (data) {
            data.forEach(item => {
                lista.push({
                    value: item.id,
                    label: item.codigo+' - ' + item.nombre
                })
            })
        }
        dispatch({type: COLABORADOR, emp: lista })
    }).catch((error) => {
        return [];
    })
}

export const datosColaborador = (emp) => (dispatch) => {
    api.get(`/colaborador/${emp}`).then((response) => {
        dispatch({type: PUESTO, cargo: response.cargo })
    }).catch((error) => {
        return [];
    })
}

export const registroBaja = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormBajaIgss.values;
    let id_empresa = '';
    if (valEmp === 'fage'){
        id_empresa = id_emp[6]
    }else{
        id_empresa = id_emp[5]
    }
    if (data === undefined) {
        Swal.fire({
            title: 'Baja de IGSS',
            text: 'Debe de seleccionar colaborador',
            type: 'error',
        })
    } else {
        if (data.fecha_suspension === undefined || data.fecha_suspension === '') {
            Swal.fire({
                title: 'Baja de IGSS',
                text: 'Debe de ingresar fecha de suspensión',
                type: 'error',
            })
        } else {
            if (data.motivo === undefined || data.motivo === '') {
                Swal.fire({
                    title: 'Baja de IGSS',
                    text: 'Debe de seleccionar motivo',
                    type: 'error',
                })
            } else {
                const formData = {
                    colaborador: data.colaborador.value,
                    fecha_suspension: data.fecha_suspension,
                    motivo: data.motivo,
                    empresa: id_empresa
                }
                dispatch(setLoader(true));
                api.post('/rrhh_baja_igss/', formData).then(() => {
                    NotificationManager.success(
                        'Baja de IGSS creado correctamente',
                        'Exito',
                        3000
                    );
                    let ruta = '';
                    if (valEmp === 'fage'){
                        ruta = `/lfg/rr_hh/${id_emp[6]}/baja_igss`
                        dispatch(push(ruta));
                    }else{
                        ruta = `/rr_hh/${id_emp[5]}/baja_igss`
                        dispatch(push(ruta));
                    }
                }).catch((error) => {
                NotificationManager.error(
                    error.msj,
                    'Error',
                    0
                );
                }).finally(() => {
                    dispatch(setLoader(false));
                });
            }
        }
    }
}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = '';
    let params;
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id };
    }else{
        id = id_emp[5];
        params = { id };
    }
    return api.get('/rrhh_baja_igss/', params).then((response)=>{
        dispatch({type: LISTADO, data: response })
    }).catch(error=>{
        NotificationManager.error(
            'Ocurrió un error al listar bajas de IGSS',
            'Error',
            0
        );
    })
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/rrhh_baja_igss/${id}`).then((response) => {
        dispatch({type: TIPO, tipo: response.motivo })
        dispatch(initializeForm('FormBajaIgss', response ));
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar bajas de IGSS',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const modificarBaja = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormBajaIgss.values;
    const id = datos.id;
    const formData = {
        id: id,
        fecha_suspension: datos.fecha_suspension,
        motivo: datos.motivoS ? datos.motivoS : datos.motivo,
    }
    dispatch(setLoader(true));
    api.put(`/rrhh_baja_igss/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Baja de IGSS modificada correctamente',
            'Exito',
            3000
        );
        let ruta = '';
        if (valEmp === 'fage'){
            ruta = `/lfg/rr_hh/${id_emp[6]}/baja_igss`
            dispatch(push(ruta));
        }else{
            ruta = `/rr_hh/${id_emp[5]}/baja_igss`
            dispatch(push(ruta));
        }
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al modificar baja de IGSS',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const limpiarDatos = () => (dispatch) => {
    dispatch({ type: PUESTO, cargo: [] });
};

const eliminar = id => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`/rrhh_baja_igss/${id}`).then(() => {
        NotificationManager.success(
            'Baja de IGSS eliminado correctamente',
            'Exito',
            3000
        );
        dispatch(listar());
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error al eliminar Baja de IGSS',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}


export const actions = {
    listarColaborador,
    getModulo,
    registroBaja,
    modificarBaja,
    datosColaborador,
    listar,
    leer,
    limpiarDatos,
    eliminar
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [COLABORADOR]: (state, { emp }) => {
        return {
            ...state,
            emp,
        };
    },
    [PUESTO]: (state, { cargo }) => {
        return {
            ...state,
            cargo,
        };
    },
    [LISTADO]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [TIPO]: (state, { tipo }) => {
        return {
            ...state,
            tipo,
        };
    },
};

export const initialState = {
    loader: false,
    modulo: [],
    data: [],
    emp: [],
    tipo: [],
};

export default handleActions(reducers, initialState)
 